import { GUIDE_STEPS, KYC_STATUS } from "@/constant/Constant";
import RouteConstant from "@/constant/RouteConstant";

export const GUIDE_STEP = {
  NEED_BIND_EMAIL: 'needBindEmail',//需要绑定邮箱
  NEED_SUBMIT_KYC_PRE: 'needSubmitKycPre',//需要提交kyc信息
  NEED_SUMSUB_KYC: 'needSumsubKyc',//sumsub kyc
  NEED_BIND_MOBILE: 'needBindMobile',//需要绑定手机号
  NEED_SUBMIT_BILL_ADDRESS: 'needSubmitBillAddress',//需要填写账单地址
  NEED_APPLY_CARD: 'needApplyCard',//需要买卡
  HAS_BUY_CARD: 'hasBuyCard',//已经买卡，流程结束
}

export const isGuideFinished = (user) => {
  return user?.step == GUIDE_STEP.HAS_BUY_CARD;
}

export const getRouteByStep = (step) => {
  if (step == GUIDE_STEP.HAS_BUY_CARD) {
    return RouteConstant.CARD_HOME;
  } else if (step == GUIDE_STEP.NEED_BIND_EMAIL) {
    return RouteConstant.GUIDE_BIND_EMAIL;
  } else if (step == GUIDE_STEP.NEED_BIND_MOBILE) {
    return RouteConstant.GUIDE_BIND_MOBILE;
  } else if (step == GUIDE_STEP.NEED_SUBMIT_BILL_ADDRESS) {
    return RouteConstant.GUIDE_BILL_ADDRESS;
  } else if (step == GUIDE_STEP.NEED_APPLY_CARD) {
    return RouteConstant.GUIDE_DEPOSIT;
    //return RouteConstant.CARD_HOME;
  } else if (step == GUIDE_STEP.NEED_SUMSUB_KYC) {
    return RouteConstant.GUIDE_KYC;
  } else if (step == GUIDE_STEP.NEED_SUBMIT_KYC_PRE) {
    return RouteConstant.GUIDE_KYC_PRE;
  }
}

export const isUserCompleteGuide = (user) => {
  return user?.isBuyCard == true;
}

export const getUserCurrentGuideStep = (user) => {
  // 绑定手机号码
  if (user.mobileStatus != 1) {
    return GUIDE_STEPS.STEP_BIND_MOBILE;
  } 
  // 检查用户是否通过KYC
  else if (user.kycStatus != KYC_STATUS.KYC_STATUS_APPROVED) {
    return GUIDE_STEPS.STEP_KYC;
  } 
  // // 是否充值
  // else if (!user.isDeposit) {
  //   return GUIDE_STEPS.STEP_DEPOST;
  // }
  // 是否购卡
  else if (!user.isBuyCard) {
    return GUIDE_STEPS.STEP_BUY_CARD;
  }
  return null;
}

export const getKYCStatusDisplay = (user, t) => {
  if (!user || isNaN(user?.kycStatus)) return '';

  if (user.kycStatus == KYC_STATUS.KYC_STATUS_APPROVED) {
    return t(`kyc_status_${user.kycStatus}`);
  }
  
  // user aml check.
  if (user.kycAmlReject == 1) {
    if (user.kycAmlDeclareSubmit) {
      return t('verifying');
    } else {
      return t('additional_info_request');
    }
  }

  return t(`kyc_status_${user.kycStatus}`);
}

export const getKYCStatusClassName = (user) => {
  if (!user) return '';

  if (user.kycStatus == KYC_STATUS.KYC_STATUS_APPROVED) {
    return 'color-success';
  } else if (user.kycStatus == KYC_STATUS.KYC_STATUS_NOT_SUBMIT || user.kycStatus == KYC_STATUS.KYC_STATUS_SUBMITTED) {
    return 'color-warning';
  } else if (user.kycStatus == KYC_STATUS.KYC_STATUS_REJECT || user.kycStatus == KYC_STATUS.KYC_STATUS_REJECT_FINAL) {
    return 'color-error';
  }
  return '';
}

export const getKYCAmlDisplay = (user, t) => {

}